"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractConnector = void 0;
const abstract_connector_1 = require("@web3-react/abstract-connector");
Object.defineProperty(exports, "AbstractConnector", { enumerable: true, get: function () { return abstract_connector_1.AbstractConnector; } });
//# sourceMappingURL=AbstractConnector.js.map